<template>
  <div>
    <div class="header-default">
      <div class="col-sm-2">
        <LogoText color="#fff" />
      </div>
      <div class="col-sm-6">
        <!-- <b class="test_name">
          剑雅12 - TEST6 - Listening - Passage 1
        </b> -->
      </div>
      <div class="col-sm-4 control">
        <el-button @click="setPage">
          Next
        </el-button>
      </div>
    </div>
    <div class="box">
      <div class="paper">
        <div class="introduction">
          <div class="incontent">
            <h1>IELTS Academic Reading</h1>
            <p>Time: 20 minutes</p>

            <h1>INSTRUCTIONS TO CANDIDATES</h1>
            <p>• Answer all the questions</p>
            <p>• You can change your answers at any time during the test</p>

            <h1>INFORMATION FOR CANDIDATES</h1>
            <p>• There are 13 questions in this test</p>
            <p>• Each question carries one mark</p>
            <p>• The test clock will show you how long have you taken</p>

            <p class="tip">Click 'Start Test' when you are ready</p>
            <div class="text-center">
              <div
                class="btn-start"
                @click="
                  $router.push({
                    name: 'IeltsTest',
                    query: $route.query
                  })
                "
              >
                Start Test
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LogoText from "@/components/LogoText";

export default {
  props: ["mode"],
  components: {
    LogoText
  },
  data() {
    return {};
  },
  watch: {},
  methods: {
    setPage() {
      if (this.page === 1) {
        this.page = 2;
      } else {
        this.$router.push({
          name: "IeltsTest",
          query: this.$route.query
        });
      }
    }
  }
};
</script>

<style scoped>
.mylogo {
  color: #fff;
  height: 80px;
  width: 100%;
  position: absolute;
  z-index: 5;
  top: 0;
  text-align: center;
  display: flex;
  align-items: center;
  /* flex-direction:row-reverse; */
  background-image: linear-gradient(-90deg, #3f49a3 0, #832a41 100%);
}
.navbar-brand {
  position: relative;
  display: block;
  margin: 15px 0;
  text-align: left;
}
.navbar-brand img {
  height: 40px;
  position: absolute;
  top: 50%;
  margin-top: -20px;
}
.header-default {
  height: 80px;
  width: 100%;
  position: absolute;
  z-index: 5;
  top: 0;
  text-align: center;
  display: flex;
  align-items: center;
}

.header-default {
  background: var(--themeColor);
  color: white;
}
.your_ansers {
  line-height: 80px;
}
.intro_screen {
  width: 100%;
}
.mylogo {
  line-height: 80px;
}
.time-container {
  margin: 0 auto;
}
.mylogo .control {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.mylogo .control .el-dropdown {
  width: 100px;
}
.mylogo .audio-speed {
  display: inline-block;
  width: 100%;
}
.header-default .control .el-dropdown span {
  color: var(--themeColor);
}
.header-default .control {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}
.box {
  padding: 0;
  background-color: #edeef2;
  height: calc(100% - 80px);
  width: 100%;
  overflow: auto;
  top: 80px;
  position: absolute;
  z-index: 10;
  bottom: 15px;
}
.paper {
  overflow: hidden;
  width: 1200px;
  font-size: 16px;
  margin: 0 auto 30px;
  background: #fff;
  padding: 30px 55px 35px 55px;
  height: auto;
}

.listening_audition_desc {
  width: 550px;
  margin: 50px auto 0;
  text-align: center;
}
.listening_audition_desc img {
  width: 500px;
  border: 1px solid #efefef;
  border-radius: 10px;
  padding: 0 20px 0 20px;
}
.tips_text1 {
  font-size: 24px;
  color: #494949;
  margin: 30px auto;
}
.tips_text2 {
  font-size: 16px;
  color: #9c9faa;
  line-height: 25px;
  height: 25px;
}
.tips_text3 {
  font-size: 16px;
  color: #9c9faa;
  line-height: 22px;
  height: 22px;
  margin-top: 15px;
}

.incontent {
  margin: 0px auto;
  width: 80.24692%;
}
.incontent h1 {
  margin-top: 20px;
  color: var(--themeColor);
  font-size: 24px;
  line-height: 2;
  font-weight: 500;
  text-align: left;
}

.incontent p {
  color: #999999;
  font-size: 20px;
  text-align: left;
  margin: 0px;
  line-height: 2;
}
p.tip {
  color: #999999;
  font-size: 16px;
  text-align: center;
  margin-top: 30px;
}
.btn-start {
  cursor: pointer;
  width: 289px;
  line-height: 53px;
  background-color: var(--themeColor);
  color: #fff;
  display: inline-block;
  font-size: 20.85px;
  border-radius: 1.2em;
  text-align: center;
  margin: 20px auto;
}
.btn-start:focus,
.btn-start:hover {
  opacity: 0.8;
}
</style>
